/* jv-bridal-prep-guide.js — vanilla JS for the Bridal Beauty Prep Guide */
(function () {
  'use strict';

  /* ── Scroll-reveal (IntersectionObserver) ───────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.prep-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList.add('is-visible');
      }
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    for (var j = 0; j < els.length; j++) {
      observer.observe(els[j]);
    }
  }

  /* ── Mode toggle (Screen / Print booklet) ───────────────────── */
  function initModeToggle() {
    var btnScreen = document.getElementById('prep-btn-screen');
    var btnPrint  = document.getElementById('prep-btn-print');
    if (!btnPrint) return;

    btnPrint.addEventListener('click', function () {
      window.print();
    });

    /* Keep "Screen" visually active on page load */
    if (btnScreen) {
      btnScreen.classList.add('prep-mode-toggle__btn--active');
    }
  }

  /* ── Smooth active-state for mode toggle ────────────────────── */
  function initToggleActive() {
    var btns = document.querySelectorAll('.prep-mode-toggle__btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) {
          b.classList.remove('prep-mode-toggle__btn--active');
        });
        btn.classList.add('prep-mode-toggle__btn--active');
      });
    });
  }

  /* ── Force FAQ details open in print ───────────────────────── */
  /* CSS handles most of this via display:block on .prep-faq__body,
     but we also set the `open` attribute so browsers that honour it
     in print don't collapse the native <details> element. */
  function initPrintFaq() {
    window.addEventListener('beforeprint', function () {
      var items = document.querySelectorAll('.prep-faq__item');
      items.forEach(function (el) { el.setAttribute('open', ''); });
    });
    window.addEventListener('afterprint', function () {
      var items = document.querySelectorAll('.prep-faq__item');
      items.forEach(function (el) { el.removeAttribute('open'); });
    });
  }

  /* ── Editor-mode: reveal all instantly (IntersectionObserver won't fire in iframe) */
  function initEditorReveal() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    document.querySelectorAll('.prep-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    /* Re-reveal on section load/select events in the editor */
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.prep-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    });
  }

  /* ── Init ───────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initEditorReveal();
    initReveal();
    initModeToggle();
    initToggleActive();
    initPrintFaq();
  });
})();
